module.exports = __webpack_public_path__ + "static/media/icon_dollar.770bf0cc.svg";